import React from 'react'
import './App.css'
import MYNavbar from './Components/Navbar'
import MYCarousel from './Components/Carousel'
import Products from './Components/Products'
import About from './Components/About'
import Partners from './Components/Partners'
import Footer from './Components/Footer'

export default function MainPage() {
    return (
        <div className="min-h-screen">
            <MYNavbar />
            <MYCarousel />
            <Products />
            <About />
            <Partners />
            <Footer />
        </div>
    )
}
